import { format, fromUnixTime } from 'date-fns';
import * as locales from 'date-fns/locale';
import { utcToZonedTime } from 'date-fns-tz';

type LocaleCollection = Record<string, Locale>;

/** Converts the specified `utcDate` into local timezone using the specified format string. */
export function formatDate(utcDate: Date, formatStr: string): string {
  const localTZ: Locale = (locales as LocaleCollection)[
    Intl.DateTimeFormat().resolvedOptions().timeZone
  ];

  const localDate: Date = utcToZonedTime(utcDate, Intl.DateTimeFormat().resolvedOptions().timeZone);
  return format(localDate, formatStr, { locale: localTZ });
}

export function formatDateUTC(date: Date, formatStr: string): string {
  const dateToUTCDate = utcToZonedTime(date, 'Etc/UTC');
  return format(dateToUTCDate, formatStr);
}

export function getFormattedDateExtended(date: Date): string {
  return formatDate(date, 'MMM d, yyyy');
}

export function getFormattedTime(date: Date): string {
  return formatDate(date, 'h:mm a');
}

// eslint-disable-next-line import/no-unused-modules
export function getFormattedDateTimeUTC(date: Date): string {
  return `${formatDateUTC(date, 'MM/dd/yyyy')}, ${formatDateUTC(date, 'h:mm a')} UTC`;
}

/* users local timezone with no GMT-X appended */
export function getFormattedTimeZoneLocal(date: Date): string {
  return formatDate(date, 'MM/dd/yyyy, h:mma');
}

function formatUnixDate(unixDate: number, formatStr: string): string {
  const localTZ: Locale = (locales as LocaleCollection)[
    Intl.DateTimeFormat().resolvedOptions().timeZone
  ];
  return format(fromUnixTime(unixDate), formatStr, { locale: localTZ });
}
export function getChartDateTime(date: number, formatStr = 'MMM d h:mma'): string {
  return formatUnixDate(date, formatStr);
}
